export var pageMeta = {};

/**
 * retrieves the current browser size
 * @returns {Record<string, any>}
 */
export var getBrowserSize = function getBrowserSize() {
  // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight
  if (typeof window.innerWidth !== 'undefined') {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }

  // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
  if (typeof document.documentElement !== 'undefined' && typeof document.documentElement.clientWidth !== 'undefined' && document.documentElement.clientWidth !== 0) {
    return {
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight
    };
  }

  // older versions of IE
  return {
    width: document.getElementsByTagName('body')[0].clientWidth,
    height: document.getElementsByTagName('body')[0].clientHeight
  };
};

/**
 * retrieves the new relic instance if it exists
 * @returns {any} new relic instance or undefined if not found
 */
export var getNewRelicInstance = function getNewRelicInstance() {
  if (window && window.newrelic) {
    return window.newrelic;
  }
  return undefined;
};

/**
 * sets page name in new relic for analytics tracking
 * @param {string} pageName
 * @returns {void}
 */
export var nrSetPage = function nrSetPage(pageName) {
  var nr = getNewRelicInstance();
  if (nr) {
    nr.setCustomAttribute('pageName', pageName);
  }
};

/**
 * sets user uuid in new relic for analytics tracking
 * @param {string} uuid
 * @returns {void}
 */
export var nrSetUser = function nrSetUser(uuid) {
  var nr = getNewRelicInstance();
  if (nr) {
    nr.setCustomAttribute('userUUID', uuid);
  }
};

/**
 * sets user language in new relic for analytics tracking
 * @returns {void}
 */
export var nrSetLanguage = function nrSetLanguage() {
  var nr = getNewRelicInstance();
  if (nr) {
    nr.setCustomAttribute('userLanguage', window.navigator.language);
  }
};

/**
 * sets screen width and screen height in new relic for analytics tracking
 * @returns {void}
 */
export var nrSetScreenSize = function nrSetScreenSize() {
  var nr = getNewRelicInstance();
  if (nr) {
    var _window = window,
      screen = _window.screen;
    nr.setCustomAttribute('screenWidth', screen.width);
    nr.setCustomAttribute('screenHeight', screen.height);
  }
};

/**
 * sets browser width and browser height in new relic for analytics tracking
 * @returns {void}
 */
export var nrSetBrowserSize = function nrSetBrowserSize() {
  var nr = getNewRelicInstance();
  if (nr) {
    var _getBrowserSize = getBrowserSize(),
      width = _getBrowserSize.width,
      height = _getBrowserSize.height;
    nr.setCustomAttribute('browserWidth', width);
    nr.setCustomAttribute('browserHeight', height);
  }
};

/**
 * initializes metadata entry for a specific page in the  pageMeta object
 * @param {string} name
 * @returns {void}
 */
export var nrSetPageMetaName = function nrSetPageMetaName(name) {
  pageMeta[name] = {
    pageName: name,
    constructTime: Date.now(),
    mountTime: Date.now(),
    unmountTime: Date.now(),
    numberOfRenders: 0
  };
};

/**
 * updates the mount time for a specific page in the pageMeta object
 * @param {string} name
 * @returns {void}
 */
export var nrSetPageMetaMountTime = function nrSetPageMetaMountTime(name) {
  if (!pageMeta[name]) {
    nrSetPageMetaName(name);
  }
  pageMeta[name].mountTime = Date.now();
};

/**
 * updates the unmount time for a specific page in the pageMeta object
 * @param {string} name
 * @returns {void}
 */
export var nrSetPageMetaUnmountTime = function nrSetPageMetaUnmountTime(name) {
  if (!pageMeta[name]) {
    nrSetPageMetaName(name);
  }
  pageMeta[name].unmountTime = Date.now();
};

/**
 * increments the number of renders for a specific page in the pageMeta object
 * @param {string} name
 * @returns {void}
 */
export var nrUpdatePageMetaRenderCount = function nrUpdatePageMetaRenderCount(name) {
  if (!pageMeta[name]) {
    nrSetPageMetaName(name);
  }
  pageMeta[name].numberOfRender += 1;
};

/**
 * sends accumulated page metadata to new relic
 * @param {string} name
 * @returns {void}
 */
export var nrSendPageMeta = function nrSendPageMeta(name) {
  if (!pageMeta[name]) {
    return;
  }
  var nr = getNewRelicInstance();
  if (nr) {
    nr.addPageAction('pageMeta', pageMeta[name]);
    delete pageMeta[name];
  }
};

/**
 * sends an error to new relic
 * @param {Error} error
 * @param {unknown} attributes
 * @returns {void}
 */
export var nrSendError = function nrSendError(error, attributes) {
  var nr = getNewRelicInstance();
  if (nr) {
    nr.noticeError(error, attributes);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/NewRelicUtils/helper.js
// module id = 3495
// module chunks = 11